<template>
  <div id="app-group-page">
    <div class="page-wrapper">
      <div class="filters">
        <div class="add-app-group">
          <div class="query-box">
            <ElForm inline @submit.native.prevent class="elementui-common-form-styles" v-highlight>
              <ElFormItem>
                <ElInput v-model="groupName" placeholder="请输入应用组名称" @keyup.enter.native="resetPageAndQuery" />
              </ElFormItem>

              <ElFormItem class="bg-transparent">
                <ElButton type="primary" @click="resetPageAndQuery">查询</ElButton>
                <ElButton @click="showAddUpdateModal">新建应用组</ElButton>
              </ElFormItem>
            </ElForm>
          </div>
        </div>
      </div>

      <div class="data-table">
        <Spin size="large" fix v-if="tableLoading"></Spin>
        <el-table class="common-el-table-styles" :data="tableData" :height="tableHeight" border style="width: 100%">
          <el-table-column prop="groupId" label="组ID" width="60"> </el-table-column>
          <el-table-column prop="groupName" width="160" show-overflow-tooltip label="应用组名"> </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="{ row }">
              <div class="table-btns">
                <el-button type="text" @click="showAddUpdateModal(row)">编辑</el-button>
                <el-button type="text" @click="removeGroupRow(row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="appNames" show-overflow-tooltip label="组内游戏"> </el-table-column>
          <el-table-column prop="createOpName" label="新建人" width="90"> </el-table-column>
          <el-table-column prop="createTime" label="新建时间" width="130">
            <template slot-scope="{ row }">
              <div>
                {{ row.createTime | datetimeToSec }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="upOpName" label="最后编辑人" width="90"> </el-table-column>
          <el-table-column prop="upTime" label="编辑时间" width="130">
            <template slot-scope="{ row }">
              <div>
                {{ row.upTime | datetimeToSec }}
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="pager">
          <Page
            :current.sync="pager.pageIndex"
            :page-size="pager.pageSize"
            :total="pager.total"
            @on-change="query"
            @on-page-size-change="query"
            size="small"
            show-total
            show-sizer
          />
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="showAddModal" title="新建应用组" width="668px">
      <AddForm ref="add-form" v-if="showAddModal" @query="query" @close="onModalcancel" />
    </el-dialog>
  </div>
</template>
<script>
import { offsetTop } from '@/common/js/utils.js'
import { queryAppGroupsByPage, removeAppGroup } from '@/api/sysmana.model.js'
import { adGames } from '@/api/common.model'
import AddForm from './components/add-group/appGorupForm.vue'

export default {
  components: { AddForm },
  data() {
    const gamesValidator = (rule, value, callback) => {
      if (!value || !value.length) callback(new Error('请选择组内游戏'))
      callback()
    }

    return {
      showAddModal: false,
      tableLoading: false,
      tableHeight: 300,
      groupName: '',
      pager: {
        total: 0,
        pageIndex: 1,
        pageSize: 30
      },
      tableData: [],
      appList: [], // 应用下拉数据
      groupForm: {
        groupName: '',
        gameIds: []
      },
      formRules: {
        groupName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        gameIds: [{ required: true, validator: gamesValidator, trigger: 'change' }]
      }
    }
  },
  created() {
    this.query()
    this.getDropdownData()
  },
  mounted() {
    this.$nextTick(() => {
      const el = document.querySelector('.data-table')
      // 页码的高度 + 页码的margin-top 10px + page-wrapper padding 16px
      const offset = offsetTop(el, el.querySelector('.pager').scrollHeight + 16 + 12)
      const h = window.innerHeight - offset
      this.tableHeight = h
    })
  },
  methods: {
    /**
     * @description: 表格数据查询
     */
    query() {
      this.tableLoading = true
      queryAppGroupsByPage({
        keyword: this.groupName,
        ...this.pager
      }).then((data) => {
        if (data) {
          const { list, page_info } = data
          this.tableData = data.list
          this.pager.total = page_info.total_number
        }
        this.tableLoading = false
      })
    },
    /**
     * @description: 应用组关键词搜索
     */
    resetPageAndQuery() {
      this.pager.pageIndex = 1
      this.query()
    },
    /**
     * @description: 显示编辑新增弹窗
     */
    showAddUpdateModal(row) {
      this.showAddModal = true

      if (row.groupId) {
        this.$nextTick(() => {
          this.$refs['add-form'].setResults(row)
        })
      }
    },

    /**
     * @description: 删除组
     */
    removeGroupRow(row) {
      this.$Modal.confirm({
        title: '确认',
        content: '确认删除该应用组？',
        onOk: () => {
          removeAppGroup({ id: row.groupId }).then((data) => {
            this.$Message.info('删除成功')
            this.resetPageAndQuery()
          })
        }
      })
    },
    /**
     * @description: 弹窗关闭
     */
    onModalcancel() {
      this.showAddModal = false
    },
    getDropdownData() {
      Promise.all([adGames()])
        .then((data) => {
          const [list] = data
          this.appList = list
        })
        .catch((err) => {
          console.log('getDropdownData err output: ', err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#app-group-page {
  padding: 0 16px;
  .page-wrapper {
    background: #fff;
    padding: 16px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    .filters {
      .add-app-group {
        display: flex;
        justify-content: space-between;
      }
    }
    .data-table {
      position: relative;

      .pager {
        text-align: right;
        margin-top: 10px;
      }
    }
  }
}
</style>
